import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";
import React from "react";

export const PromoCodeForm = props => {
  const { warningMsg, isFetchingValidation } = props;

  return (
    <>
      <div>Enter your unique promo code. Make sure it’s easy to remember and alphanumeric.</div>

      <Row className="margin-top--large">
        <Col xs={12} md={6}>
          <div>
            <span className="redcircle-form-label">Promo Code</span>
          </div>
          <Field
            placeholder="e.x. REDCIRCLE"
            component="input"
            type="text"
            name="promoCode"
            className="form-control margin-bottom--small"
            normalize={value => value && value.toUpperCase()}
          />
          {!isFetchingValidation && warningMsg && (
            <span className={"text-warning small"}>{warningMsg}</span>
          )}
          {isFetchingValidation && <span className={"gray small"}>Verifying promo code...</span>}
          {!warningMsg && !isFetchingValidation && (
            <span className="text-success small">Your promo code is available!</span>
          )}
        </Col>
      </Row>
    </>
  );
};
